import { Box } from "@mui/material"
import React from "react"
import { useShallow } from "zustand/shallow"

import { UOM_RENDER_PRECISION } from "@/constants/formats"
import { type Order } from "@/graphql/codegen/graphql"
import { formatPalletCount } from "@/screens/WarehouseReceiving/utils"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { formatNumber } from "@/utils/number"
import { getDisplayableOrderWeightTotals } from "@/utils/purchaseOrder"

interface PurchaseOrderQuantityPalletsCellProps {
  order: Order
}

export const PurchaseOrderQuantityPalletsCell: React.FC<PurchaseOrderQuantityPalletsCellProps> = ({ order }) => {
  const units = useUnitOfMeasurementsStore(useShallow((s) => s.units))
  const totals = order.totals

  const { usWeight, usUom } = getDisplayableOrderWeightTotals(totals, units)

  return (
    <Box>
      {formatPalletCount(totals?.pallets ?? 0)} ({formatNumber(usWeight?.amount ?? 0, UOM_RENDER_PRECISION)}{" "}
      {usUom?.name})
    </Box>
  )
}
